
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path d="M17.3529 17.5294L15 18L15.4706 15.6471L21.1176 10L23 11.8824L17.3529 17.5294Z"></path><path d="M13 20L17 19L20.6667 15.5V19.5C20.6667 20.1631 20.4033 20.799 19.9344 21.2678C19.4656 21.7366 18.8297 22 18.1667 22H6.5C5.83696 22 5.20107 21.7366 4.73223 21.2678C4.26339 20.799 4 20.1631 4 19.5V12.8334C4 12.1703 4.26339 11.5344 4.73223 11.0656C5.20107 10.5968 5.83696 10.3334 6.5 10.3334H18.1667C18.5585 10.3334 18.9409 10.4254 19.2849 10.5974L14 16L13 20Z"></path><path d="M17.3334 8.66667H15.6667V7.00001C15.676 6.12593 15.338 5.2839 14.7269 4.65889C14.1158 4.03388 13.2816 3.677 12.4075 3.66667H12.3725C11.9371 3.65906 11.5043 3.73734 11.0991 3.89704C10.6939 4.05673 10.3241 4.29472 10.0109 4.5974C9.69771 4.90007 9.44723 5.2615 9.27378 5.66103C9.10033 6.06056 9.00731 6.49035 9.00004 6.92584V8.66667H7.33337V6.91667C7.34675 5.60977 7.87463 4.36079 8.80262 3.44045C9.7306 2.52011 10.9839 2.00257 12.2909 2.00001H12.3417C12.999 1.99879 13.65 2.12763 14.2572 2.37909C14.8645 2.63056 15.416 2.99969 15.88 3.46522C16.3439 3.93075 16.7112 4.48347 16.9607 5.09156C17.2101 5.69965 17.3368 6.35109 17.3334 7.00834V8.66667Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowchangePasswordFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
